export const IMAGE_EXTENSION_TYPE =['jpg', 'png', 'jpeg', 'mpeg']
export const APPLICATION_TITLE_MAX_CHAR = 26;